import React from 'react';
import ContactUs from '../../About/ContactUs/ContactUs';
import TrustUsBanner from '../TrustUsBanner/TrustUsBanner';
import TrustUsDescription from '../TrustUsDescription/TrustUsDescription';

const WhyTrustUs = () => {
    return (
        <div>
            <TrustUsBanner />
            <TrustUsDescription />
            <ContactUs />
        </div>
    );
};

export default WhyTrustUs;